import { ImportExecutionListView } from '@today/ui-domain'
import { useNavigate } from 'react-router-dom'
import { useImportExecutionList } from '@/hooks/imports/useImportExecutionList'

/** `/t/:slug/admin/imports` — the tenant's import executions (TO-399 REQ-009). */
export function ImportsListPage() {
	const navigate = useNavigate()
	const list = useImportExecutionList((id) => void navigate(id))
	return (
		<div className="flex flex-col gap-6 p-6">
			<ImportExecutionListView {...list} />
		</div>
	)
}
